import { useSearchParams } from 'react-router-dom';
import { googleLoginUrl } from '../lib/api';

export function LoginPage() {
  const [params] = useSearchParams();
  const error = params.get('error');
  const messages: Record<string, string> = {
    google_denied: 'คุณยกเลิกการอนุญาต Google กรุณาลองใหม่เมื่อพร้อม',
    refresh_token_missing: 'Google ไม่ส่ง Refresh Token กรุณาถอนสิทธิ์แอปในบัญชี Google แล้วเชื่อมต่อใหม่',
    session: 'ไม่สามารถตรวจสอบเซสชันได้ กรุณาเข้าสู่ระบบใหม่',
  };
  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-b from-teal-50 to-slate-50 p-5">
      <section className="w-full max-w-md rounded-3xl border border-white bg-white p-6 shadow-xl shadow-teal-900/10 sm:p-8">
        <img src="/icon.svg" alt="" className="mx-auto h-20 w-20 rounded-3xl shadow-lg" />
        <h1 className="mt-6 text-center text-2xl font-bold text-slate-900">นัดหมายจากภาพ</h1>
        <p className="mt-2 text-center leading-relaxed text-slate-600">
          ถ่ายใบนัด ตรวจข้อมูล แล้วเพิ่มลง Google Calendar อย่างปลอดภัย
        </p>
        {error && <p role="alert" className="mt-5 rounded-xl bg-amber-50 p-3 text-sm text-amber-900">{messages[error] ?? 'เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่'}</p>}
        <a href={googleLoginUrl()} className="btn-primary mt-6 w-full gap-3">
          <span className="rounded-full bg-white px-2 py-0.5 font-bold text-blue-600">G</span>
          เข้าสู่ระบบด้วย Google
        </a>
        <p className="mt-5 text-center text-xs leading-relaxed text-slate-500">
          ระบบจะขอสิทธิ์เฉพาะข้อมูลบัญชีและการจัดการกิจกรรมปฏิทิน ไฟล์เอกสารจะไม่เปิดเผยสาธารณะ
        </p>
      </section>
    </main>
  );
}
